export default "__VITE_ASSET__C_fBuvlZ__"